export class MakeshopInfo {
    constructor(data) {
        this.data = data
    }

    getOptionsInfo() {
        return this.data?.options_info || false
    }

    getProductInfo() {
        return this.data?.product_info || {}
    }

    getShopInfo() {
        return this.data?.shop_info || {}
    }

    getCategoryInfo() {
        return this.data?.product_info?.option_category || {};
    }


    getBrandUid() {
        return this.getProductInfo()?.branduid || false;
    }

    getAdminuser() {
        return "inna"; //this.getShopInfo()?.shop_id || false;
    }
}